import React, {useState, useEffect} from 'react';
import {Button, Typography, Layout} from 'antd';
import {useNavigate} from 'react-router-dom';
import AppHeader from '../../components/AppHeader/AppHeader';
import {oauthService} from '../../services/api';
import '../../../../App.css';

const {Text, Title} = Typography;
const {Content} = Layout;

// SVG иконка для кнопки входа
const IdSvgIcon = () => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.0323 0H6.96774C3.11956 0 0 3.11956 0 6.96774V17.0323C0 20.8804 3.11956 24 6.96774 24H17.0323C20.8804 24 24 20.8804 24 17.0323V6.96774C24 3.11956 20.8804 0 17.0323 0ZM7.15394 6.9375H12.0001C12.6535 6.9375 13.2732 7.09707 13.7098 7.45514C14.1048 7.77903 14.5097 8.39537 14.5097 9.67614C14.5097 10.71 14.1442 11.2313 13.7472 11.5297C13.2976 11.8677 12.6554 12.0284 12.0001 12.0284C11.3245 12.0284 10.6863 11.8785 10.2451 11.5528C9.86258 11.2705 9.49047 10.7584 9.49047 9.67614H7.24047C7.24047 11.3757 7.87798 12.6022 8.90897 13.3631C9.88116 14.0806 11.0603 14.2784 12.0001 14.2784C12.9602 14.2784 14.1353 14.0528 15.0991 13.3282C16.1156 12.5642 16.7597 11.3468 16.7597 9.67614C16.7597 7.86599 16.155 6.55051 15.1365 5.71532C14.1597 4.9143 12.9621 4.6875 12.0001 4.6875H7.15394V6.9375ZM7.71469 19.2602C7.60141 19.3405 7.49188 19.4182 7.38482 19.4913L6.11536 17.6337C6.20487 17.5725 6.30305 17.5023 6.41049 17.4254C7.37752 16.7338 9.09473 15.5057 12.0001 15.5057C15.22 15.5057 17.0894 16.9956 17.9514 17.6828L16.5488 19.4422C15.7953 18.8414 14.4334 17.7557 12.0001 17.7557C9.83687 17.7557 8.64827 18.5983 7.71469 19.2602Z"
            fill="#1C1D20"
        />
    </svg>
);

const LoginPage = () => {
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        // Проверка авторизации при загрузке страницы
        if (oauthService.isAuthenticated()) {
            navigate('/');
        }
    }, [navigate]);

    const handleLogin = async () => {
        setLoading(true);
        try {
            const authUrl = await oauthService.initOAuth();
            window.location.href = authUrl;
        } catch (error) {
            console.error('Ошибка инициализации OAuth:', error);
            setLoading(false);
        }
    };

    return (
        <Layout style={{minHeight: '100vh'}}>
            <AppHeader/>
            <Content style={{display: 'flex', justifyContent: 'center', alignItems: 'center', padding: '24px'}}>
                <div style={{width: '100%', maxWidth: '400px', textAlign: 'center'}}>
                    <Title level={3}>Авторизация в POS</Title>
                    <Text type="secondary">Выберите способ входа для начала работы</Text>

                    <Button
                        type="primary"
                        size="large"
                        icon={<IdSvgIcon/>}
                        loading={loading}
                        onClick={handleLogin}
                        block
                        style={{height: '48px', marginTop: '24px'}}
                    >
                        Войти с 116 ID
                    </Button>

                    <Button
                        type="default"
                        size="large"
                        onClick={() => navigate('/device/login')}
                        block
                        style={{ height: '48px', marginTop: '16px' }}
                    >
                        Войти как устройство
                    </Button>
                </div>
            </Content>
        </Layout>
    );
};

export default LoginPage;